import { apiRemote } from "@/api";
import { Box, Container, Typography, Grid, Card, CardContent, Button, Chip, CardMedia } from "@mui/material"
import { useCallback, useEffect, useState } from "react";

const liveItems = [
  {
    tag: "Live Workshop",
    tagColor: "#2A79E2",
    title: "AI Prompting for Teachers",
    description: "Learn to craft effective prompts to save time and create amazing resources.",
    buttonText: "Save Your Spot",
    prominent: false,
  },
  {
    tag: "Trending Discussion",
    tagColor: "#F28C28",
    title: '"How are you *really* handling student plagiarism in the age of AI?"',
    description:
      '"I\'m struggling with this. One of my students submitted an essay that was clearly... *too good*. What are some practical strategies that have worked for you all?" - Sarah J.',
    buttonText: "Weigh In on This Topic",
    prominent: true,
  },
  {
    tag: "Coming Soon",
    tagColor: "#777",
    title: "Preview: The Ultimate PBL Toolkit",
    description: "Get a sneak peek at the kind of time-saving resources our Marketplace will offer.",
    buttonText: "Get Launch Updates",
    prominent: false,
  },
]

export default function LiveNowSection() {
  const [loading, setLoading] = useState<boolean>(false);
  const [activities, setActivities] = useState<any[]>([]);

  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await apiRemote.getUpcomingWorkshop(userTimeZone);
      console.log(response);
      setActivities(response.data || [])
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  }, []);
  
  useEffect(() => {
    fetchData();
  }, [fetchData]);
  return (
    <Box sx={{ backgroundColor: "background.paper", py: 12 }}>
      <Container maxWidth="xl">
        <Typography variant="h2" sx={{ textAlign: "center", mb: 6 }}>
          Live on Pythaverse Now
        </Typography>

        <Grid container spacing={4} sx={{ alignItems: "stretch" }}>
          {/* {liveItems.map((item, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  transform: item.prominent ? { md: "scale(1.05)" } : "none",
                  zIndex: item.prominent ? 10 : 1,
                  boxShadow: "0 4px 25px rgba(0,0,0,0.05)",
                }}
              >
                <CardContent sx={{ p: 3, display: "flex", flexDirection: "column", height: "100%" }}>
                  <Chip
                    label={item.tag}
                    sx={{
                      backgroundColor: item.tagColor,
                      color: "white",
                      fontWeight: 600,
                      fontSize: "0.8rem",
                      mb: 2,
                      alignSelf: "flex-start",
                    }}
                  />

                  <Typography variant="h4" sx={{ mb: 2, fontSize: "1.3rem" }}>
                    {item.title}
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 3, flexGrow: 1 }}>
                    {item.description}
                  </Typography>

                  <Button
                    variant={item.prominent ? "contained" : "outlined"}
                    color="primary"
                    sx={{
                      mt: "auto",
                      ...(item.prominent
                        ? {}
                        : {
                            backgroundColor: "white",
                            borderColor: "#e0e0e0",
                            color: "primary.light",
                            "&:hover": {
                              borderColor: "primary.light",
                            },
                          }),
                    }}
                  >
                    {item.buttonText}
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))} */}
          {loading ? (
              <Grid item xs={12} textAlign="center">
                  <Typography>Loading...</Typography>
              </Grid>
          ) : (
              // Map qua mảng activities đã được fetch
              activities.map((activity, index) => (
                  <Grid item xs={12} sm={6} md={3} key={index}>
                      <Card
                          sx={{
                              height: "100%",
                              boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
                              transition: "transform 0.3s, box-shadow 0.3s",
                              "&:hover": {
                                  transform: "translateY(-5px)",
                                  boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
                              },
                          }}
                      >
                          {/* Sử dụng activity.image */}
                          {activity.type == 'Workshops' ? (
                            // <CardMedia component="img" height="180" image={activity.image_url} alt={activity.title} />
                            <></>
                          ) : activity.type == 'Community' ? (
                            // <CardMedia height="180" component="img"  alt={activity.title} />
                            <></>
                          ) : (
                            // <CardMedia component="img" height="180" image={"https://via.placeholder.com/600x400?text=No+Image+Available"} alt={activity.title} />
                            <></>
                          )}
                          
                          <CardContent sx={{ p: 3, display: "flex", flexDirection: "column", height: "100%" }}>
                              <Chip
                                  // Sử dụng activity.tag
                                  label={activity.type}
                                  size="small"
                                  sx={{
                                      backgroundColor: "#007BFF",
                                      color: "white",
                                      fontWeight: 600,
                                      fontSize: "0.8rem",
                                      mb: 2,
                                      alignSelf: "flex-start",
                                  }}
                              />
                              <Typography
                                  variant="h6"
                                  component="h4"
                                  sx={{
                                      fontWeight: 600,
                                      color: "#003366",
                                      mb: 1,
                                      fontSize: "1.1rem",
                                  }}
                              >
                                  {/* Sử dụng activity.title */}
                                  {activity.title}
                              </Typography>
                              
                              {activity.type == 'Workshops' ? (
                                <Typography variant="body1" sx={{
                                    mb: 3,
                                    flexGrow: 1,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 3, // Giới hạn 3 dòng
                                    WebkitBoxOrient: 'vertical',
                                }}>
                                  {activity.description}
                                </Typography>
                              ) : activity.type == 'Community' ? (
                                <Typography variant="body1" sx={{
                                    mb: 3,
                                    flexGrow: 1,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 3, // Giới hạn 3 dòng
                                    WebkitBoxOrient: 'vertical',
                                }}>
                                  {activity.short_content}
                                </Typography>
                              ) : (
                                // <CardMedia component="img" height="180" image={"https://via.placeholder.com/600x400?text=No+Image+Available"} alt={activity.title} />
                                <></>
                              )}
                              {activity.type == 'Workshops' ? (
                                  <Typography
                                      variant="body2"
                                      sx={{
                                          color: "#007BFF",
                                          fontWeight: 600,
                                          cursor: "pointer",
                                      }}
                                      component="a" // Biến Typography thành link
                                      href={`https://${process.env.API_HOST}/educatalyst/detail/${activity.id}`} // Sử dụng originalLink đã lưu
                                      target="_blank" // Mở trong tab mới
                                      rel="noopener noreferrer" // Bảo mật
                                  >
                                      Learn More →
                                  </Typography>
                              ) : activity.type == 'Community' ? (
                                  <Typography
                                      variant="body2"
                                      sx={{
                                          color: "#007BFF",
                                          fontWeight: 600,
                                          cursor: "pointer",
                                      }}
                                      component="a" // Biến Typography thành link
                                      href={activity.link} // Sử dụng originalLink đã lưu
                                      target="_blank" // Mở trong tab mới
                                      rel="noopener noreferrer" // Bảo mật
                                  >
                                      Join Discussion →
                                  </Typography>
                              ) : (
                                  // Đây là trường hợp mặc định nếu activity.tag không phải 'Workshop' hoặc 'Community'
                                  // Bạn có thể đặt một link/văn bản mặc định ở đây, hoặc không hiển thị gì cả
                                  <Typography
                                      variant="body2"
                                      sx={{
                                          color: "#007BFF",
                                          fontWeight: 600,
                                          cursor: "pointer",
                                      }}
                                      component="a"
                                      href={activity.originalLink || "#"} // Đảm bảo có link dự phòng
                                      target="_blank"
                                      rel="noopener noreferrer"
                                  >
                                      View more → {/* Hiển thị link hoặc văn bản mặc định */}
                                  </Typography>
                              )}
                              
                          </CardContent>
                      </Card>
                  </Grid>
              ))
          )}
        </Grid>
      </Container>
    </Box>
  )
}
